const C = require("../constants");

const selectPrice = price => {
  return {
      type: C.SELECT_PRICE,
      price
  }
};

export {selectPrice};


// WEBPACK FOOTER //
// ./src/actions/PricesActions.js